import { HttpClient } from '@angular/common/http';
import { Component, inject } from '@angular/core';
import { Router, RouterOutlet } from "@angular/router";
import { AppSettings } from './app.globals';
import { PubSubService } from '@shared/services/pubsub.service';
import { AppInsightsService } from '@shared/services/app-insights.service';
import { NotificationComponent } from './shared/components/notification.component';

@Component({
    selector: 'bh-app',
    templateUrl: 'app.component.html',
    // these are singletons and should NOT be "providers" anywhere else
    providers: [PubSubService, AppSettings],
    imports: [RouterOutlet, NotificationComponent]
})
export class AppComponent {
    private http = inject(HttpClient);
    private router = inject(Router);
    private appInsightsService = inject(AppInsightsService);

    constructor() {
        const appInsightsService = this.appInsightsService;

        if (!appInsightsService.isInitialized) {
            appInsightsService.init();
        }
    }
}


